export const TITRE_VITRINE_MAX_LENGTH = 47
export const TITRE_FICHE_MAX_LENGTH = 20

/**
 * Retourne le titre à afficher sur les fiches vitrine.
 * Si le titre dépasse 47 caractères et qu'un titre alternatif est renseigné, on utilise celui-ci.
 */
export function getTitreAlternatif (post) {
  if (!post) {
    return ''
  }

  const titre = post.titre || ''
  const titreAlternatif = post.titre_alternatif || ''

  if (titre.length > TITRE_VITRINE_MAX_LENGTH && titreAlternatif.trim()) {
    return titreAlternatif
  }

  return titre
}
